module.exports = __webpack_public_path__ + "static/media/webinar.028da2df.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/webinar.webp
// module id = 543
// module chunks = 4